module.exports = __webpack_public_path__ + "static/img/2_5_2.89e02623.jpg";